import { useEffect } from "preact/hooks";

import { ExpandMapButton } from "./components/ExpandMapButton";
import { FilterBar } from "./components/FilterBar";
import { Header } from "./components/Header";
import { MapView } from "./components/MapView";
import { StationList } from "./components/StationList";
import { loadStations } from "./data";
import { t } from "./i18n";
import { loadError, loading, mapMode, stations } from "./state";

export function App() {
  useEffect(() => {
    let cancelled = false;
    loading.value = true;
    loadError.value = null;
    loadStations()
      .then((data) => {
        if (cancelled) return;
        stations.value = data;
      })
      .catch((err: Error) => {
        if (cancelled) return;
        loadError.value = err.message;
      })
      .finally(() => {
        if (!cancelled) loading.value = false;
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div class={`app-shell app-shell--${mapMode.value}`}>
      <Header />
      <FilterBar />
      <main class="main-area">
        <MapView />
        <ExpandMapButton />
        {loading.value && <p class="status overlay">{t("loading")}</p>}
        {loadError.value && (
          <p class="status status-error overlay">
            {t("error_loading")}: {loadError.value}
          </p>
        )}
      </main>
      <StationList />
    </div>
  );
}
